<template>
  <svg
      data-name="レイヤー 1"
      id="レイヤー_1"
      viewBox="0 0 21.95 27.01"
      xmlns="http://www.w3.org/2000/svg"
  >
    <g
        data-name="レイヤー 2"
        id="レイヤー_2"
    >
      <g id="contents">
        <path
            :style="`fill:${accentColor}`"
            d="M4.76,27a4.35,4.35,0,0,1-2.16-.64,4.92,4.92,0,0,1-2.43-3,6.91,6.91,0,0,1,1-5.2l8.76-15A6.51,6.51,0,0,1,18.76.85a6.42,6.42,0,0,1,3,3.91,6.3,6.3,0,0,1-.65,4.84l-8.75,15A1,1,0,0,1,11,25h0a1,1,0,0,1-.36-1.37h0l8.76-15a4.38,4.38,0,0,0-1.64-6,4.52,4.52,0,0,0-6.1,1.61L2.9,19.2a5,5,0,0,0-.8,3.67,3,3,0,0,0,1.49,1.79c1.55.89,2.46.31,4.22-2.69l4.92-8.42c.6-1,1.34-2.27,1.17-2.91,0-.07-.08-.29-.51-.53a1.38,1.38,0,0,0-1.63.43l-6,10.28L4,19.77,10,9.49a3.38,3.38,0,0,1,4.34-1.16,2.87,2.87,0,0,1,1.45,1.75c.38,1.45-.51,3-1.37,4.44L9.53,22.94C8.64,24.46,7.16,27,4.76,27Z"
            transform="translate(-0.03 0.01)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "ClipIcon",
  data() {
    return {
      accentColor: null,
    }
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
  },
}
</script>

<style>

</style>